import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
export default {
  name: 'AgencyMatchmakerMonthlySettlementList',
  data: function data() {
    return {
      apiUrl: process.env.VUE_APP_API,
      isSelect: this.checkauthority('agencyMonthlySettlement_select'),
      isExport: this.checkauthority('agencyMonthlySettlement_export'),
      selectForm: {
        mSettlementId: null,
        agencyId: null,
        settlementTime: null,
        settlementAccount: null,
        deductionsAccount: null,
        actualSettlement: null,
        createTime: null,
        settlementTimes: [],
        settlementSts: 0,
        matchmakerName: null
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    settlementALlApi: function settlementALlApi() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return api.MATCHMAKERMONTHLYSETTLEMENTAll();
            case 1:
              _this.$message.success('操作成功');
              _context.n = 2;
              return _this.initTableData();
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    settlementAll: function settlementAll() {
      var _this2 = this;
      this.$confirm('确定要进行全局结算操作吗， 是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.settlementALlApi();
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消结算'
        });
      });
    },
    /**
     * 单个结算。
     */
    settlement: function settlement(row) {
      var _this3 = this;
      this.$confirm('确定要进行结算操作吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.settlementApi(row.msettlementId);
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    /**
     * 结算Api
     * @param settlementId
     * @returns {Promise<void>}
     */
    settlementApi: function settlementApi(settlementId) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {};
              if (settlementId !== null) {
                par.settlementId = settlementId;
              }
              _context2.n = 1;
              return api.MATCHMAKERMONTHLYSETTLEMENT(par);
            case 1:
              _this4.$message.success('操作成功');
              _context2.n = 2;
              return _this4.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        settlementTime: this.selectForm.settlementTime,
        settlementSts: this.selectForm.settlementSts,
        matchmakerName: this.selectForm.matchmakerName
      };
      if (this.selectForm.settlementTimes.length >= 2) {
        par.startSettlementTime = this.selectForm.settlementTimes[0];
        par.endSettlementTime = this.selectForm.settlementTimes[1];
      }
      var apiUrl = 'admin/v1/byMatchmakerMonthlySettlement/export';
      if (this.selectForm.settlementSts === 0) {
        this.downloadUtil.excelExport(apiUrl, par, '红娘待结算明细表.xls');
      } else {
        this.downloadUtil.excelExport(apiUrl, par, '红娘结算记录表.xls');
      }
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this5.enumList = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this6 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this6.daleteApi(index, data);
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                mSettlementId: data.mSettlementId
              };
              _context4.n = 1;
              return api.DELETE_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this7.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.DELETE_BATCH_AGENCYMONTHLYSETTLEMENT(par);
            case 1:
              _this8.$message.success('操作成功');
              _this8.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this9 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this9.tableSelects.forEach(function (element) {
          par.push(element.mSettlementId);
        });
        _this9.deleteBatchApi(par);
      }).catch(function () {
        _this9.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.edit.setTitle('新增');
      this.editDisabled = false;
      this.dialogVisible = true;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.mSettlementId = null;
      this.selectForm.agencyId = null;
      this.selectForm.settlementTime = null;
      this.selectForm.settlementAccount = null;
      this.selectForm.deductionsAccount = null;
      this.selectForm.actualSettlement = null;
      this.selectForm.createTime = null;
      this.selectForm.settlementTimes = [];
      this.selectForm.settlementSts = 0;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this0 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this0.pageNo,
                pageSize: _this0.pageSize,
                settlementTime: _this0.selectForm.settlementTime,
                settlementSts: _this0.selectForm.settlementSts,
                matchmakerName: _this0.selectForm.matchmakerName
              };
              if (_this0.selectForm.settlementTimes.length >= 2) {
                par.startSettlementTime = _this0.selectForm.settlementTimes[0];
                par.endSettlementTime = _this0.selectForm.settlementTimes[1];
              }
              _context6.n = 1;
              return api.GET_MATCHMAKERMONTHLYSETTLEMENT_PAGE_LIST(par);
            case 1:
              res = _context6.v;
              _this0.tableData = res.body.datas;
              _this0.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};